module.exports = __webpack_public_path__ + "static/media/igor@2x.51cf3ff0.png";